/* src/app/shared/dialogs/ag-filter-dialog/ag-filter-dialog.component.scss */
.gray-overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 95;
  display: inline-flex;
  justify-content: flex-end;
}
.drawer {
  width: 0px;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 100;
  height: 100vh;
  background-color: #ffffff;
  border-bottom-left-radius: 16px;
  border-top-left-radius: 16px;
  display: flex;
  flex-direction: column;
  transition: width 0.175s ease-in-out;
}
.drawer-header {
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-width: 375px !important;
  border-bottom: 1px solid #dfdfdf;
  height: 68px;
}
.drawer-header img {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.sidebar-scroll {
  height: calc(100vh - 168px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-left: 7px;
}
.filter {
  padding: 16px 0px;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #dfdfdf;
  min-width: 375px !important;
}
.filter .clear-button {
  color: #6e89da;
  font-size: 14px;
  font-family: "Poppins-Semibold";
  text-decoration: underline;
  cursor: pointer;
}
.filter .filter-button {
  width: 100%;
  min-width: 375px !important;
  border: none;
  cursor: pointer;
  padding: 8px 24px;
  gap: 10px;
  display: flex;
}
.filter .filter-button img {
  width: 20px;
  height: 20px;
}
.filter .filter-button:hover {
  background-color: #f2f2f2;
}
.spandOutput {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  gap: 8px;
  padding: 0 24px;
}
.spandOutput .spandInput {
  display: flex;
  height: 56px;
  min-height: 40px;
  width: 155.5px;
  padding: 13px 16px;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  align-self: stretch;
  border: 1px solid transparent;
  border-radius: 12px;
  outline: none;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  background-color: #f2f2f2;
  color: #222222;
}
.spandOutput .spandInput::-webkit-outer-spin-button,
.spandOutput .spandInput::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.spandOutput .spandInput[type=number] {
  -moz-appearance: textfield;
}
.spandOutput .focused {
  border: 1px solid #222222;
  color: #222222;
}
.drawer-footer {
  margin-top: auto;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100px;
  min-width: 375px !important;
  border-top: 1px solid #dfdfdf;
}
@media (max-width: 575px) {
  .drawer {
    border-top-left-radius: 0% !important;
    border-bottom-left-radius: 0% !important;
    z-index: 100000 !important;
  }
}
/*# sourceMappingURL=ag-filter-dialog.component.css.map */
